module.exports = __webpack_public_path__ + "media/assets/images/icons/gdt-icons-80f51c1c063d4d3627ce62ae638353b2.svg";